export const createDetailsLink = (pathFunc, linkName) => ({
  path: pathFunc,
  linkName,
});
